import { CustomTranslation } from "./custom-translation";
import { ProductEditRowState } from "./products-table/product-edit-row-state";

export class ProductCompositionEditRowState extends ProductEditRowState {
	get productDescription():string{
		return this._productDescription;
	}
	set productDescription(value:string){
		this._productDescription = value;
		this.translatedDescription.Fallback = value;
	}

	translatedDescription:CustomTranslation = new CustomTranslation();

}